// @ts-nocheck
// Shoe Bubbles Animation - Uses custom bubble image from Shopify
(function() {
  function initBubbles() {
    // Check for GSAP
    if (typeof gsap === 'undefined') {
      console.warn('GSAP not loaded. Bubbles animation disabled.');
      return;
    }
    
    const shoesContainer = document.querySelector('.shoes-container');
    const shoeElements = document.querySelectorAll('.shoe');
    
    if (!shoeElements.length) return;
    
    // Get bubble images from data attributes
    const bubbleImageUrls = (shoesContainer?.dataset.bubbleImages || '')
      .split('||')
      .map((url) => url.trim())
      .filter(Boolean);
    const singleBubbleImageUrl = shoesContainer?.dataset.bubbleImage;
    if (!bubbleImageUrls.length && !singleBubbleImageUrl) {
      console.warn('No bubble image configured. Add one in Shopify theme editor.');
      return;
    }

    const bubbleImageSource = bubbleImageUrls.length
      ? bubbleImageUrls
      : [singleBubbleImageUrl].filter(Boolean);
    let bubbleImagePool = [];
    let lastBubbleImage = '';

    const refillBubbleImagePool = () => {
      bubbleImagePool = [...bubbleImageSource];

      for (let index = bubbleImagePool.length - 1; index > 0; index--) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [bubbleImagePool[index], bubbleImagePool[randomIndex]] = [bubbleImagePool[randomIndex], bubbleImagePool[index]];
      }

      if (bubbleImagePool.length > 1 && bubbleImagePool[0] === lastBubbleImage) {
        const swapIndex = 1 + Math.floor(Math.random() * (bubbleImagePool.length - 1));
        [bubbleImagePool[0], bubbleImagePool[swapIndex]] = [bubbleImagePool[swapIndex], bubbleImagePool[0]];
      }
    };

    const getRandomBubbleImage = () => {
      if (!bubbleImagePool.length) {
        refillBubbleImagePool();
      }

      const nextBubbleImage = bubbleImagePool.pop() || bubbleImageSource[0];
      lastBubbleImage = nextBubbleImage;
      return nextBubbleImage;
    };

    let bubbleLayer = document.querySelector('.shoe-bubble-layer');
    if (!bubbleLayer) {
      bubbleLayer = document.createElement('div');
      bubbleLayer.className = 'shoe-bubble-layer';
      document.body.appendChild(bubbleLayer);
    }
  
    // Configuration - SLOW continuous bubbles, only fast on scroll
    const config = {
      spawnRateMin: 150,
      spawnRateMax: 300,
      maxBubbles: 40,
      baseSpeedMin: 10,    // Very slow: 10-16 seconds
      baseSpeedMax: 16,
      minSize: 9,
      maxSize: 50
    };

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const bubbleConfig = {
      spawnRateMin: isMobile ? Math.round(config.spawnRateMin * 2) : config.spawnRateMin,
      spawnRateMax: isMobile ? Math.round(config.spawnRateMax * 1.25) : config.spawnRateMax,
      maxBubbles: isMobile ? Math.round(config.maxBubbles * 0.75) : config.maxBubbles
    };

    const initFloatingAnimation = () => {
      const floatMultiplier = isMobile ? 1 : 1.25;

      gsap.to('.shoe-left', {
        y: -14 * floatMultiplier,
        x: -9 * floatMultiplier,
        rotation: -10 * floatMultiplier,
        duration: 3.2,
        ease: 'sine.inOut',
        yoyo: true,
        repeat: -1
      });

      gsap.to('.shoe-right', {
        y: -13 * floatMultiplier,
        x: 9 * floatMultiplier,
        rotation: 10 * floatMultiplier,
        duration: 3.6,
        ease: 'sine.inOut',
        yoyo: true,
        repeat: -1
      });

      if (!isMobile) {
        gsap.to('.shoe', {
          scale: 1.025,
          duration: 2.8,
          ease: 'sine.inOut',
          yoyo: true,
          repeat: -1
        });
      }
    };

    initFloatingAnimation();
  
    // Initialize bubble system for each shoe
    shoeElements.forEach((shoe) => {
    
      let bubbleCount = 0;
    
      function spawnBubble() {
        // Always schedule next bubble first for continuous flow
        scheduleNextBubble();
        
        if (bubbleCount >= bubbleConfig.maxBubbles) {
          return;
        }
      
        // Create bubble element with per-bubble image/mask vars
        const bubbleImageUrl = getRandomBubbleImage();
        const bubble = document.createElement('div');
        bubble.className = 'shoe-bubble';
      
        // Random size (small, medium, large distribution)
        const sizeRoll = Math.random();
        let size;
        if (sizeRoll < 0.45) {
          size = config.minSize + Math.random() * 10.2; // Small: 8.5-19px
        } else if (sizeRoll < 0.8) {
          size = 17 + Math.random() * 12.75; // Medium: 17-30px
        } else {
          size = (29.75 + Math.random() * 12.75) * 0.9; // Large: 10% smaller
        }
      
        // Start position from current shoe position in viewport
        const shoeRect = shoe.getBoundingClientRect();
        const startX = shoeRect.left + shoeRect.width * (0.02 + Math.random() * 0.96);
        const startY = shoeRect.top + shoeRect.height * (0.75 + Math.random() * 0.25);
      
        // No opacity change - image as-is
        bubble.style.cssText = `
          width: ${size}px;
          height: ${size}px;
          left: ${startX}px;
          top: ${startY}px;
        `;
        bubble.style.setProperty('--bubble-image-url', `url("${bubbleImageUrl}")`);
        bubble.style.setProperty('--bubble-mask-url', `url("${bubbleImageUrl}")`);
      
        bubbleLayer.appendChild(bubble);
        bubbleCount++;
      
        // Animation duration based on size (smaller = faster, but all slow)
        const durationBase = config.baseSpeedMin + (size / config.maxSize) * (config.baseSpeedMax - config.baseSpeedMin);
        const duration = durationBase * (0.9 + Math.random() * 0.25);
      
        // Horizontal drift
        const driftX = (Math.random() - 0.5) * (60 + Math.random() * 90);
        const riseOffset = 110 + Math.random() * 180;
        const wobbleOffset = (Math.random() - 0.5) * (35 + Math.random() * 45);
        const wobbleDurationFactor = 0.14 + Math.random() * 0.18;
        const wobbleRepeats = 3 + Math.floor(Math.random() * 5);
        const scaleTarget = 1.05 + Math.random() * 0.35;
        const rotationTarget = (Math.random() - 0.5) * (15 + Math.random() * 35);
        const rotationDurationFactor = 0.25 + Math.random() * 0.35;
        const rotationRepeats = 2 + Math.floor(Math.random() * 4);
      
        // GSAP Timeline for smooth animation
        const tl = gsap.timeline({
          onComplete: () => {
            bubble.remove();
            bubbleCount--;
          }
        });
      
        // Float upward with drift - main animation (sube hasta salir completamente)
        tl.to(bubble, {
          y: -(startY + riseOffset),
          x: driftX,
          duration: duration,
          ease: 'none'
        }, 0);
      
        // Wobble effect (side to side movement)
        tl.to(bubble, {
          x: `+=${wobbleOffset}`,
          duration: duration * wobbleDurationFactor,
          ease: 'sine.inOut',
          repeat: wobbleRepeats,
          yoyo: true
        }, 0);
      
        // Scale slightly as it rises (bubbles expand)
        tl.to(bubble, {
          scale: scaleTarget,
          duration: duration,
          ease: 'power1.out'
        }, 0);
      
        // Subtle rotation
        tl.to(bubble, {
          rotation: rotationTarget,
          duration: duration * rotationDurationFactor,
          ease: 'sine.inOut',
          yoyo: true,
          repeat: rotationRepeats
        }, 0);
      }
    
      function scheduleNextBubble() {
        let delay = bubbleConfig.spawnRateMin + Math.random() * (bubbleConfig.spawnRateMax - bubbleConfig.spawnRateMin);
        delay *= 0.75 + Math.random() * 0.7;

        if (Math.random() < 0.15) {
          delay += 120 + Math.random() * 280;
        }

        setTimeout(spawnBubble, delay);
      }
    
      // Start spawning immediately with slight stagger per shoe
      setTimeout(spawnBubble, Math.random() * 100);
    });

    // Parallax effect for shoe links - subtle movement opposite to mouse
    const shoeLinks = document.querySelectorAll('.shoe-link');
    if (shoeLinks.length > 0 && typeof gsap !== 'undefined') {
      shoeLinks.forEach((link) => {
        const shoe = link.closest('.shoe');
        if (!shoe) return;

        link.addEventListener('mousemove', (e) => {
          const rect = link.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;

          // Calculate mouse position relative to center (-1 to 1)
          const mouseX = (e.clientX - centerX) / (rect.width / 2);
          const mouseY = (e.clientY - centerY) / (rect.height / 2);

          // Move in opposite direction, very subtle (max 8px)
          const moveX = -mouseX * 8;
          const moveY = -mouseY * 8;

          gsap.to(link, {
            x: moveX,
            y: moveY,
            duration: 0.5,
            ease: 'power2.out',
            overwrite: 'auto'
          });
        });

        link.addEventListener('mouseleave', () => {
          gsap.to(link, {
            x: 0,
            y: 0,
            duration: 0.6,
            ease: 'power2.out',
            overwrite: 'auto'
          });
        });
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBubbles);
  } else {
    initBubbles();
  }
})();